import { DailyHabitPlan } from 'src/models/dailyHabit/DailyHabitPlan';
import HomeWidgetTextStore from 'src/stores/HomeWidgetTextStore';
import { DailyHabitPlanState } from 'src/utils/enums';

interface DailyHabitPlanStatusProps {
  hasInProgressPlans: boolean
  completedPlanNames: string[]
  failedPlanNames: string[]
  hasCompletedOrFailedPlans: boolean
}
export const useDailyHabitPlanStatus = (userPlans: DailyHabitPlan[], homeWidgetTextStore: HomeWidgetTextStore): DailyHabitPlanStatusProps => {
  const hasInProgressPlans = userPlans?.some((plan: DailyHabitPlan) => (plan.state === DailyHabitPlanState.InProgress));
  const completedPlanNames = userPlans?.filter((plan: DailyHabitPlan) =>
    (plan.state === DailyHabitPlanState.Completed)).map((plan: DailyHabitPlan) => homeWidgetTextStore.getHomeWidgetText(`Goals:${plan.id}:Name`)) || [];
  const failedPlanNames = userPlans?.filter((plan: DailyHabitPlan) =>
    (plan.state === DailyHabitPlanState.Failed)).map((plan: DailyHabitPlan) => homeWidgetTextStore.getHomeWidgetText(`Goals:${plan.id}:Name`)) || [];

  const hasCompletedOrFailedPlans = completedPlanNames.length > 0 || failedPlanNames.length > 0;

  return {
    hasInProgressPlans,
    completedPlanNames,
    failedPlanNames,
    hasCompletedOrFailedPlans,
  };
};
